export function precisionRound(number, precision) {
    var factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
}


// WEBPACK FOOTER //
// ./src/utils.js